import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

/* 폭 15rem — 시안 w-60 스냅. */
export const sideNavStyle = css`
  display: flex;
  flex-direction: column;
  width: 15rem;
  flex-shrink: 0;
  /* 본문이 길어져도 늘어나지 않고 뷰포트 높이에 딱 맞게 고정 — footer 항상 노출.
     sticky + 100vh + align-self로 flex stretch를 막고 화면에 붙여 둔다. */
  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 100vh;
  background: ${theme.color.navBg};
  color: ${theme.color.onNav}B3;
`;

export const brandStyle = css`
  padding: ${theme.space.md}px ${theme.space.md}px;
  border-bottom: 1px solid ${theme.color.onNav}1A;
  font-size: ${theme.fontSize.lg}px;
  font-weight: 700;
  color: ${theme.color.onNav};

  p {
    margin: ${theme.space.xs}px 0 0;
    font-size: ${theme.fontSize.sm}px;
    font-weight: 400;
    color: ${theme.color.onNav}80;
  }
`;

export const navStyle = css`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: ${theme.space.xs}px;
  padding: ${theme.space.md}px ${theme.space.sm}px;
  font-size: ${theme.fontSize.md}px;
  /* 항목이 많아 뷰포트를 넘으면 이 목록만 스크롤 — footer는 그대로 하단 고정. */
  overflow-y: auto;
`;

export const navItemStyle = (active: boolean) => css`
  display: flex;
  align-items: center;
  gap: ${theme.space.sm}px;
  padding: ${theme.space.sm}px ${theme.space.md}px;
  border: none;
  border-radius: ${theme.radius.md}px;
  cursor: pointer;
  font: inherit;
  text-align: left;
  background: ${active ? theme.color.primarySoft : 'transparent'};
  color: ${active ? theme.color.primary : `${theme.color.onNav}B3`};
  font-weight: ${active ? 600 : 400};

  &:hover {
    background: ${active ? theme.color.primarySoft : `${theme.color.onNav}0D`};
  }
`;

export const footerStyle = css`
  padding: ${theme.space.md}px;
  border-top: 1px solid ${theme.color.onNav}1A;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.onNav}80;

  > div {
    display: flex;
    align-items: center;
    gap: ${theme.space.sm}px;
  }

  p {
    margin: ${theme.space.xs}px 0 0;
  }
`;

/* 8px 고정 상태점. */
export const statusDotStyle = css`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: ${theme.radius.pill}px;
  background: ${theme.color.success};
`;
